import { $http } from "@/assets/js/appFunc";

let testPromise = null;

export const test = (store, forceReload) => {
    if (!testPromise && !forceReload) {
        testPromise = $http({
            path: "/path/to/ajaxCall",
            type: "GET"
        }).then((obj) => {
            store.commit("test", obj);
            return obj;
        });
    }

    return testPromise;
};
